import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { z } from "zod";
import { ZodExtended } from "@/data/zod.extended";
import { CommonModels } from "@/data/common/common.models";
import { ProfileAnalyticsModels } from "./profileAnalytics.models";

export namespace ProfileAnalyticsApi {
export const getGradeScore = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileAnalyticsGradeResponseDtoSchema }, 
        `/profile-analytics/grade`,
        
    )
};

export const getCompletion = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileAnalyticsCompletionResponseDtoSchema }, 
        `/profile-analytics/completion`,
        
    )
};

export const getSkillDiagram = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileAnalyticsSkillDiagramResponseDtoSchema }, 
        `/profile-analytics/skill-diagram`,
        
    )
};

export const getBlsSkillIndustry = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileBlsSkillIndustryResponseDtoSchema }, 
        `/profile-analytics/bls-skill-industry`,
        
    )
};

export const getStrengthsWeaknesses = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileAnalyticsStrengthsWeaknessesResponseDtoSchema }, 
        `/profile-analytics/strengths-weaknesses`,
        
    )
};

export const getActionPrioritiesV2 = (size?: number, strategy?: ProfileAnalyticsModels.GetActionPrioritiesV2StrategyParam, ) => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileAnalyticsActionPrioritiesV2ResponseDtoSchema }, 
        `/profile-analytics/action-priorities-v2`,
        {
    params: {
        size: ZodExtended.parse(z.number().nullish(), size, { type: "query", name: "size" })
, 
        strategy: ZodExtended.parse(ProfileAnalyticsModels.GetActionPrioritiesV2StrategyParamSchema.optional(), strategy, { type: "query", name: "strategy" })
, 
    },
}
    )
};

export const getIndustryFitRank = () => { 
    return AppRestClient.get( 
        { resSchema: ProfileAnalyticsModels.ProfileAnalyticsIndustryFitRankResponseDtoSchema }, 
        `/profile-analytics/industry-fit-rank`,
        
    )
};

}
